import * as React from "react";
const SvgIconCheck = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.7 9.25c-.4 0-.75-.15-1-.4L1.5 6.7l1-1.1 2.15 2.15L9.5 3l1 1.1-4.75 4.75c-.3.25-.65.4-1.05.4" }));
export default SvgIconCheck;
